<template>
  <v-card max-width="426" class="mx-auto pa-6 text-center">
    <h2 class="text-capitalize text-h5 text--secondary my-5 text-center">
      {{ $t("auth.forgetPassword.title") }}
    </h2>
    <v-form @submit.prevent="onSubmit" ref="passwordRecovery">
      <v-text-field
        type="text"
        :placeholder="$t('auth.forgetPassword.form.username')"
        :rules="emailRules"
        filled
        autofocus
        v-model="email"
        class="theme-custom-input ma-auto"
      />

      <v-card-actions class="pa-0 auth-btn">
        <v-btn
          color="primary"
          :loading="loading"
          block
          class="py-7"
          type="submit"
        >
          {{ $t("auth.forgetPassword.form.nextButton") }}
        </v-btn>
      </v-card-actions>

      <v-row justify="start" class="mt-4">
        <v-btn
          text
          color="primary"
          class="text-capitalize"
          :to="{ name: 'loginForm' }"
        >
          <v-icon
            size="20"
            :color="$vuetify.theme.themes.light.primary"
            :class="['me-2', { 'icon-rotation': $vuetify.rtl }]"
          >
            mdi-arrow-left-thin
          </v-icon>

          <span class="font-medium-14">
            {{ $t("auth.forgetPassword.backButton") }}
          </span>
        </v-btn>
      </v-row>
    </v-form>
  </v-card>
</template>
<script>
import { authService } from "@/services";
// import { mapActions } from "vuex";

export default {
  name: "forget-pass-comp",
  components: {},
  props: [],
  data() {
    return {
      loading: false,
      email: "",
      emailRules: [
        val => !!val || this.$t("auth.forgetPassword.form.usernameNotEmpty")
      ]
    };
  },
  computed: {},
  mounted() {
    localStorage.removeItem("otpToken");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  },
  methods: {
    // ...mapActions({
    //   otpData: "Auth1/SET_OTP_TOKEN_DATA"
    // }),
    onSubmit() {
      if (!this.$refs.passwordRecovery.validate()) {
        return;
      }
      this.loading = true;
      authService
        .forgetPassword(this.email)
        .then(response => {
          if (response.data) {
            localStorage.setItem("otpToken", response.data.otpToken);
            this.$router.push({ name: "emailVerification" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
@import "ForgetPassword";
</style>
